import React from "react";
import {Route, Switch} from "react-router-dom";
import EventPage from "components/EventPage";
import "./style.less";
import {UserProvider} from "../../context";
import EventListPage from "../EventListPage";
import PageNotFound from "../PageLayout/PageNotFound";

export default () => {
    return (
        <UserProvider>
            <Switch>
                <Route path="/" exact component={EventListPage} />
                <Route path="/event/:eventPassword" component={EventPage} />
                <Route path="/"><PageNotFound /></Route>
            </Switch>
        </UserProvider>
    );
};
